export default "__VITE_ASSET__CtF4dpNn__"